export default {
	salepoint: (state) => state.props.salepoint,
	loadingActions: (state) => state.props.loadingActions || []
};
